import { render, staticRenderFns } from "./ExternalQuality.vue?vue&type=template&id=5d138183&scoped=true"
import script from "./ExternalQuality.vue?vue&type=script&lang=js"
export * from "./ExternalQuality.vue?vue&type=script&lang=js"
import style0 from "./ExternalQuality.vue?vue&type=style&index=0&id=5d138183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d138183",
  null
  
)

export default component.exports